import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";
import { claimStrings } from "@/i18n/claimStrings";

const LanguageContext = createContext(null);
const LANGS = ["en", "vi", "ko"];

const detectBrowserLang = () => {
  const candidates =
    navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ""];
  for (const tag of candidates) {
    const base = (tag || "").toLowerCase().slice(0, 2);
    if (base === "vi") return "vi";
    if (base === "ko") return "ko";
    if (base === "en") return "en";
  }
  return "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("dc-lang");
    return LANGS.includes(saved) ? saved : detectBrowserLang();
  });

  const setLang = (next) => {
    if (!LANGS.includes(next)) return;
    localStorage.setItem("dc-lang", next);
    setLangState(next);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: { ...translations[lang], claim: claimStrings[lang] } }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
